import React from "react";
import { Card, CardContent, Typography, Box, Tooltip, IconButton } from "@mui/material";
import { People as UsersIcon, InfoOutlined as InfoIcon } from "@mui/icons-material";
import "./Dashboard.scss";

const ActiveUsersCard = ({ activeUsers, loading }) => {
  return (
    <Card className="active-users-card">
      <CardContent>
        <Box className="active-users-content">
          <UsersIcon className="users-icon" fontSize="large" />
          <Box sx={{ flex: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="h6" className="card-title">
                Active Users (28 Days)
              </Typography>
              <Tooltip
                title="Users who logged in or were active in the Mobile / Web App in the past 28 days"
                arrow
                placement="top"
              >
                <IconButton size="small" sx={{ p: 0.5 }}>
                  <InfoIcon sx={{ fontSize: "1rem", color: "#666" }} />
                </IconButton>
              </Tooltip>
            </Box>
            {loading ? (
              <Typography variant="h3" className="users-count loading">
                ...
              </Typography>
            ) : (
              <Typography variant="h3" className="users-count">
                {activeUsers?.toLocaleString() || "0"}
              </Typography>
            )}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ActiveUsersCard;
